var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#3749E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2632 8.73603C11.2491 8.73514 8.04214 10.6356 8.00014 10.6518C7.9907 10.6464 4.75562 8.7317 4.74023 8.73364C4.74807 8.74514 7.99798 13.3337 8.00014 13.3337C8.00236 13.3337 11.2632 8.73603 11.2632 8.73603Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00189 2.66675L4.75098 8.10386L8.00189 10.0295L11.2529 8.10386L8.00189 2.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthe);
export default __webpack_public_path__ + "static/media/ethe.881174e96427545384987711350ecc00.svg";
export { ForwardRef as ReactComponent };